/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ZoomInputs */



/**
* | output |
* | --- |
* | "Zoom..." |
*
* @param {ZoomInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const zoom = /** @type {((inputs?: ZoomInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ZoomInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Zoom...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zoom...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Zoom...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Приблизить...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Zoom...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("飞涨...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ズーム...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ज़ूम...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Zoom...")
	return /** @type {LocalizedString} */ ("Zoom...")
});